// import {initializeApp, auth} from "firebase/compat/app"
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyAiGzqFSzObeaTTP5ahHPofh6EqoCQIPFo",
  authDomain: "tnt-fuels.firebaseapp.com",
  projectId: "tnt-fuels",
  storageBucket: "tnt-fuels.firebasestorage.app",
  messagingSenderId: "1004490604377",
  appId: "1:1004490604377:web:b1d67f5ceb6cf79f331648"
};
export const firebaseApp = initializeApp(firebaseConfig);
// export const auth = firebaseApp.auth();

export const auth = getAuth();